import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { timestamp } from "./Timestamp.module.scss";

const TEN_MINUTES = 600;
const ONE_HOUR = 3600;
const TEN_HOURS = 36000;

const formattedTime = (seconds, trimLeadingZeros) => {
  let from = 11;
  let length = 8;
  if (trimLeadingZeros) {
    if (seconds < TEN_MINUTES) {
      from = 15;
      length = 4;
    } else if (seconds < ONE_HOUR) {
      from = 14;
      length = 5;
    } else if (seconds < TEN_HOURS) {
      from = 12;
      length = 7;
    }
  }
  return new Date(1000 * seconds).toISOString().substr(from, length);
};

const Timestamp = ({ className, seconds, trimLeadingZeros }) => (
  <span className={classNames(timestamp, className)}>
    { formattedTime(seconds, trimLeadingZeros) }
  </span>
);

Timestamp.propTypes = {
  className: PropTypes.string,
  seconds: PropTypes.number,
  trimLeadingZeros: PropTypes.bool
};

Timestamp.defaultProps = {
  className: "",
  seconds: 0,
  trimLeadingZeros: false
};

export default Timestamp;
